import { FC, useState } from 'react';
import { Dialog, DialogContent, DialogTrigger } from '@components/shared/Dialog';
import { InterruptProcess } from '@components/shared/InterruptProcess';
import CloserIcon from '@components/icons/CloserIcon/CloserIcon';

import styles from './InterruptProcessDialog.module.scss';
type InterruptProcessDialogProps = {
  saveProcessData?: () => Promise<void>;
  redirectToPublicSite: () => void;
};

export const InterruptProcessDialog: FC<InterruptProcessDialogProps> = ({ saveProcessData, redirectToPublicSite }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <button className={styles.CloseButton}>
          <CloserIcon />
        </button>
      </DialogTrigger>
      <DialogContent overlayClassName={styles.DialogOverlay} className={styles.DialogContent}>
        <InterruptProcess
          saveProcessData={saveProcessData}
          redirectToPublicSite={redirectToPublicSite}
          setDialogState={setIsDialogOpen}
        />
      </DialogContent>
    </Dialog>
  );
};
